export enum BlockStyle {
  inlineBlock = 1,
  block = 2
}
